export function getInstantGameById(games, gameId) {
    return games?.instant.find((game) => game.id === Number(gameId));
}

export function getDbgGameById(games, gameId) {
    return games?.dbg.find((game) => game.id === Number(gameId));
}
